export default __webpack_public_path__ + "static/media/Ceilinglight.cd93a107.JPG";